﻿import { GuiListGeneric } from "../GuiListGeneric";
export class GuiListBefoerderer extends GuiListGeneric {

    constructor() {
        super("Befoerderer");

    }

}


